module.exports = __webpack_public_path__ + "static/media/TreasureChest.8ed50abb.glb";